import { type BaseEvent, type EventParticipant, type EventType, getCurrentUserRole, getCurrentUserRsvp } from 'models';
import { useUser } from 'features/auth';
import { EventActions } from '../event-actions';

type P = {
  event: {
    author?: string;
    dialInInformation?: BaseEvent['dialInInformation'];
    endTime: Date;
    id: string;
    participants: Array<Pick<EventParticipant, 'ref' | 'role' | 'rsvp'>>;
    startTime: Date;
    status: BaseEvent['status'];
    type: EventType;
  };
};

const EventContent = ({ event }: P) => {
  const { nodeUserData: nodeViewer } = useUser();
  const { author, dialInInformation, endTime, id, participants, startTime, status } = event;
  const currentUserRsvp = getCurrentUserRsvp({ participants, viewerId: nodeViewer._id });
  const currentUserRole = getCurrentUserRole({ participants, viewerId: nodeViewer._id });

  if (status === 'canceled' || event.type === 'reminder') {
    return null;
  }

  return (
    <EventActions
      event={{
        author,
        dialInInformation,
        endTime,
        id,
        role: currentUserRole,
        rsvp: currentUserRsvp,
        startTime,
        status,
      }}
      hasLabel
    />
  );
};

export default EventContent;
